import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GuestCardsListComponent } from './guest-cards-list.component';
import { AuthGuard } from '@eceos/arch';

export const routes: Routes = [
  {
    path: 'guestCards',
    component: GuestCardsListComponent,
    data: { title: 'e-Ceos PDV - Comandas' },
    canActivate: [AuthGuard]
  }
];

export const GuestCardsRoutes: ModuleWithProviders<RouterModule> = RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' });
